import { CookiesSectionDef } from './types';
import { CloudflareIcon, FacebookIcon, GoogleIcon, StripeIcon } from './icons';

export const cookieSections: CookiesSectionDef[] = [
  {
    key: 'necessary',
    name: 'components.cookieConsent.necessary',
    isRequired: true,
    description: 'components.cookieConsent.necessaryDescription',
    subsections: [
      {
        name: 'Stripe',
        description: 'components.cookieConsent.stripeDescription',
        Icon: StripeIcon,
        cookies: [
          {
            name: '__stripe_sid',
            description: 'components.cookieConsent.stripeCookieSubscription',
            expiry: { key: 'components.cookieConsent.minute', count: 30 },
            type: 'HTTP',
          },
          {
            name: '__stripe_mid',
            description: 'components.cookieConsent.stripeCookieSubscription',
            expiry: { key: 'components.cookieConsent.year', count: 1 },
            type: 'HTTP',
          },
          {
            name: 'm',
            description: 'components.cookieConsent.stripeCookieSubscription',
            expiry: { key: 'components.cookieConsent.year', count: 2 },
            type: 'HTTP',
          },
          {
            name: 'cookie-perms',
            description: 'components.cookieConsent.cookiePermsDescription',
            expiry: { key: 'components.cookieConsent.month', count: 6 },
            type: 'HTTP',
          },
        ],
      },
      {
        name: 'Google',
        description: 'components.cookieConsent.googleDescription',
        Icon: GoogleIcon,
        cookies: [
          {
            name: 'G_ENABLED_IDPS',
            description: 'components.cookieConsent.googleSingleSignOnDescription',
            expiry: 'components.cookieConsent.infinity',
            type: 'HTTP',
          },
          {
            name: 'NID',
            description: 'components.cookieConsent.googleServicesDescription',
            expiry: { key: 'components.cookieConsent.month', count: 6 },
            type: 'HTTP',
          },
          {
            name: '1P_JAR',
            description: 'components.cookieConsent.googleServicesDescription',
            expiry: { key: 'components.cookieConsent.month', count: 1 },
            type: 'HTTP',
          },
          {
            name: 'SID',
            description: 'components.cookieConsent.googleServicesDescription',
            expiry: { key: 'components.cookieConsent.year', count: 2 },
            type: 'HTTP',
          },
          {
            name: 'SSID',
            description: 'components.cookieConsent.googleServicesDescription',
            expiry: { key: 'components.cookieConsent.year', count: 2 },
            type: 'HTTP',
          },
          {
            name: 'HSID',
            description: 'components.cookieConsent.googleServicesDescription',
            expiry: { key: 'components.cookieConsent.year', count: 2 },
            type: 'HTTP',
          },
          {
            name: 'SIDCC',
            description: 'components.cookieConsent.googleServicesDescription',
            expiry: { key: 'components.cookieConsent.year', count: 1 },
            type: 'HTTP',
          },
          {
            name: 'APISID',
            description: 'components.cookieConsent.googleServicesDescription',
            expiry: { key: 'components.cookieConsent.year', count: 2 },
            type: 'HTTP',
          },
          {
            name: '__Secure-1PSID',
            description: 'components.cookieConsent.googleServicesDescription',
            expiry: { key: 'components.cookieConsent.year', count: 2 },
            type: 'HTTP',
          },
          {
            name: '__Secure-1PAPISID',
            description: 'components.cookieConsent.googleServicesDescription',
            expiry: { key: 'components.cookieConsent.year', count: 2 },
            type: 'HTTP',
          },
          {
            name: '__Secure-3PAPISID',
            description: 'components.cookieConsent.googleServicesDescription',
            expiry: { key: 'components.cookieConsent.year', count: 2 },
            type: 'HTTP',
          },
          {
            name: '__Secure-3PSID',
            description: 'components.cookieConsent.googleServicesDescription',
            expiry: { key: 'components.cookieConsent.year', count: 2 },
            type: 'HTTP',
          },
          {
            name: '__Secure-3PSIDCC',
            description: 'components.cookieConsent.googleServicesDescription',
            expiry: { key: 'components.cookieConsent.year', count: 1 },
            type: 'HTTP',
          },
          {
            name: '__Secure-APISID',
            description: 'components.cookieConsent.googleServicesDescription',
            expiry: { key: 'components.cookieConsent.year', count: 2 },
            type: 'HTTP',
          },
          {
            name: '__Secure-HSID',
            description: 'components.cookieConsent.googleServicesDescription',
            expiry: { key: 'components.cookieConsent.year', count: 2 },
            type: 'HTTP',
          },
          {
            name: '__Secure-SSID',
            description: 'components.cookieConsent.googleServicesDescription',
            expiry: { key: 'components.cookieConsent.year', count: 2 },
            type: 'HTTP',
          },
        ],
      },
      {
        name: 'Cloudflare',
        description: 'components.cookieConsent.cloudflareDescription',
        Icon: CloudflareIcon,
        cookies: [
          {
            name: '__cf_bm',
            description: 'components.cookieConsent.cloudflareBotDescription',
            expiry: { key: 'components.cookieConsent.minute', count: 30 },
            type: 'HTTP',
          },
        ],
      },
    ],
  },
  {
    key: 'statistics',
    name: 'components.cookieConsent.statistical',
    isRequired: false,
    description: 'components.cookieConsent.statisticalDescription',
    subsections: [
      {
        name: 'Google Analytics',
        description: 'components.cookieConsent.googleAnalyticsDescription',
        Icon: GoogleIcon,
        cookies: [
          {
            name: 'DV',
            description: 'components.cookieConsent.googleAnalyticsVisitorsDescription',
            expiry: { key: 'components.cookieConsent.hour', count: 6 },
            type: 'HTTP',
          },
          {
            name: 'OTZ',
            description: 'components.cookieConsent.googleAnalyticsVisitorsDescription',
            expiry: { key: 'components.cookieConsent.year', count: 2 },
            type: 'HTTP',
          },
          {
            name: '_gat',
            description: 'components.cookieConsent.googleAnalyticsThrottleDescription',
            expiry: { key: 'components.cookieConsent.minute', count: 1 },
            type: 'HTTP',
          },
          {
            name: '_gid',
            description: 'components.cookieConsent.googleAnalyticsUsersDescription',
            expiry: { key: 'components.cookieConsent.hour', count: 24 },
            type: 'HTTP',
          },
        ],
      },
      {
        name: 'Facebook Pixel',
        description: 'components.cookieConsent.facebookPixelDescription',
        Icon: FacebookIcon,
        cookies: [
          {
            name: '_fbp',
            description: 'components.cookieConsent.facebookUsersDescription',
            expiry: { key: 'components.cookieConsent.month', count: 15 },
            type: 'HTTP',
          },
          {
            name: 'fr',
            description: 'components.cookieConsent.facebookAdsDescription',
            expiry: { key: 'components.cookieConsent.month', count: 3 },
            type: 'HTTP',
          },
          {
            name: 'datr',
            description: 'components.cookieConsent.facebookVisitorsDescription',
            expiry: { key: 'components.cookieConsent.year', count: 2 },
            type: 'HTTP',
          },
        ],
      },
    ],
  },
];
